export const states = [
  "Not Started",
  "Active",
  "Code Review",
  "Ready for test",
  "Testing",
  "Closed",
];
